import { useEffect, useState } from "react";

// Listens to window online/offline events and renders a red banner at the
// top of the screen while offline. Scanning is disabled by the parent —
// this component is purely the visible indicator.
export function OfflineBanner(): JSX.Element | null {
  const [online, setOnline] = useState<boolean>(() => navigator.onLine);

  useEffect(() => {
    const goOnline = (): void => setOnline(true);
    const goOffline = (): void => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    // Sync once in case the status changed before the listeners attached.
    setOnline(navigator.onLine);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online) {
    return null;
  }

  return (
    <div
      role="alert"
      className="absolute inset-x-0 top-0 z-20 bg-red-600 px-4 py-3 text-center text-sm font-semibold uppercase tracking-wide text-white"
    >
      No connection — scanning disabled
    </div>
  );
}
